<template>
	<section :class="{ active: menuOpen }" @click="clickSideBar">
		<side-nav-component></side-nav-component>
	</section>
</template>

<script>

import { mapGetters, mapState } from 'vuex';
import SideNavComponent from './SideNavComponent';

export default {

	computed: {

		...mapGetters([ 'inSetupGuide', 'currentAccount' ]),

		...mapState({
			menuOpen: state => state.layout.menuOpen,
		}),
	},

	watch:{

		$route() {
			this.closeMenu();
		},

	},

	methods: {

		closeMenu() {
			this.$store.dispatch('closeMenu');
		},

		clickSideBar(e) {
			const path = e.path || (event.composedPath && event.composedPath());
			path.forEach(path => {
				if (path.tagName && path.tagName.toLowerCase() === 'a' && path.classList.contains('active')) {
					this.closeMenu();
				}
			});
		},


	},

	components: {
		SideNavComponent,
	},
};

</script>
